export default {
  'gift.name': 'Quà tặng',
  //Ranking gifts list
  'gift.ranking.title': 'Danh sách quà tặng xếp hạng',
  'gift.ranking.tab': 'Quà tặng xếp hạng',

  'gift.ranking.order': 'Thứ tự giải thưởng',
  'gift.ranking.id': 'Mã quà tặng',
  'gift.ranking.name': 'Tên quà tặng',
  'gift.ranking.prize-name': 'Tên giải',
  'gift.ranking.weekly-quantity': 'Số quà mỗi tuần',
  'gift.ranking.quantity': 'Số lượng',
  'gift.ranking.type': 'Loại quà',
  'gift.ranking.type--artifact': 'Hiện vật',
  'gift.ranking.type--voucher': 'Voucher',

  'gift.ranking.button.transfer': 'Chuyển quà',
  'gift.ranking.button.sortOrder': 'Sắp xếp thứ tự giải thưởng',
  'gift.ranking.button.chooseGiftWinner': 'Chọn khách hàng nhận quà',
  'gift.confirm.delete': 'Bạn có xác nhận xóa quà này?',
  //add/edit page
  'gift.other.title': 'Danh sách quà khác',
  'gift.other.tab': 'Quà khác',

  'addGift.name': 'Thêm quà tặng',
  'addGift.ranking.title': 'Thêm quà tặng xếp hạng',
  'addGift.other.title': 'Thêm quà tặng khác',

  'updateGift.name': 'Cập nhật quà tặng',
  'updateGift.ranking.title': 'Cập nhật quà tặng xếp hạng',
  'updateGift.other.title': 'Cập nhật quà tặng khác',

  'addGift.form.type': 'Loại quà',
  'addGift.form.id': 'Mã quà tặng',
  'addGift.form.name': 'Tên quà tặng',
  'addGift.form.prize-name': 'Tên giải',
  'addGift.form.quantity': 'Tổng số lượng quà tặng',
  'addGift.form.weekly-quantity': 'Số lượng quà mỗi tuần',
  'addGift.form.image': 'Hình ảnh',
  //sort ranking gifts page
  'sortRankingGift.name': 'Sắp xếp thứ tự giải thưởng',
  'sortRankingGift.title': 'Sắp xếp thứ tự giải thưởng',

  'sortRankingGift.table.order': 'Thứ tự giải thưởng',
  'sortRankingGift.table.id': 'Mã quà tặng',
  'sortRankingGift.table.name': 'Tên quà tặng',
  'sortRankingGift.table.prize-name': 'Tên giải',
  'sortRankingGift.table.weekly-quantity': 'Số quà mỗi tuần',
  'sortRankingGift.table.quantity': 'Số lượng',
  'sortRankingGift.table.type': 'Loại quà',

  'sortRankingGift.move-top': 'Đẩy lên đầu',
  'sortRankingGift.move-bottom': 'Đẩy xuống cuối',
  'sortRankingGift.button.saveConfirm': 'Bạn có xác nhận lưu thay đổi?',
  'sortRankingGift.button.discardChange': 'Bạn có xác nhận hủy bỏ thay đổi?',

  //choose gift winner
  'giftGiving.title': 'Chọn người dùng phát quà',
  'giftGiving.table.title': 'Chọn người dùng phát quà',
  'giftGiving.display-table.title': 'Danh sách người nhận quà',

  'giftGiving.filter.cumulative-greenCoin': 'Green Coin tích lũy',
  'giftGiving.filter.week-ranking': 'Xếp hạng tuần',
  'giftGiving.filter.overall-ranking': 'Xếp hạng Overall',

  'giftGiving.name': 'Tên người dùng',
  'giftGiving.phoneNumber': 'Số điện thoại',
  'giftGiving.accumulatedCoins': 'Green coin tích lũy',
  'giftGiving.currentWeekRanking': 'Xếp hạng tuần',
  'giftGiving.selectedWeekRanking': 'Xếp hạng tuần',
  'giftGiving.overallRanking': 'Xếp hạng overall',
  'giftGiving.filter': 'Bộ lọc',
  'giftGiving.filterBy': 'Đang lọc theo',
  'giftGiving.week': 'tuần',
  'giftGiving.rank': 'hạng',
  'giftGiving.currentWeek': 'Tuần hiện tại',
  'giftGiving.rankingWeek': 'Chọn tuần xếp hạng',

  'giftGiving.button.deselect': 'Bỏ chọn',
  'giftGiving.button.reward': 'Tặng quà',
  'giftGiving.button.rewardConfirm': 'Bạn có xác nhận tặng quà?',
  //info page
  'giftInfo.name': 'Thông tin quà tặng',
  'giftInfo.ranking.gift.title': 'Thông tin quà tặng xếp hạng',
  'giftInfo.ranking.customer.title': 'Danh sách khách hàng nhận quà tặng xếp hạng',
  'giftInfo.other.gift.title': 'Thông tin quà khác',
  'giftInfo.other.customer.title': 'Danh sách khách hàng nhận quà khác',

  'giftInfo.card.id': 'Mã quà tặng',
  'giftInfo.card.name': 'Tên quà tặng',
  'giftInfo.card.type': 'Loại quà',
  'giftInfo.card.quantity': 'Tổng số lượng quà',
  'giftInfo.card.distributedQuantity': 'Số lượng quà đã phát',
  'giftInfo.card.undistributedGift': 'Số lượng quà chưa phát',
  'giftInfo.card.image': 'Hình ảnh',

  'giftInfo.table.name': 'Tên khách hàng',
  'giftInfo.table.phone': 'Số điện thoại',
  'giftInfo.table.giftSource': 'Nguồn quà tặng',
  'giftInfo.table.giftSource--award': 'Admin trao tặng',
  'giftInfo.table.giftSource--rank': 'Xếp hạng',
  'giftInfo.table.giftSource--bonus': 'Quà tặng kèm item',
  'giftInfo.table.rewardTime': 'Thời gian nhận thưởng',

  'giftInfo.table.rank': 'Xếp hạng',
  'giftInfo.table.ranking': 'Hạng',
  'giftInfo.table.week': 'Tuần xếp hạng',
  'giftInfo.table.greenCoin': 'Số Green Coin',

  //Voucher

  'voucher-import.title-Other': 'Thêm voucher cho quà tặng khác',
  'voucher-import.title-Ranking': 'Thêm voucher cho quà tặng xếp hạng',
  'modal-import.file': 'Chọn file',
  'modal-import.title': 'Nhập voucher cho quà tặng',
  'voucher-import.title': 'Quản lý voucher của',
  'modal-voucher-import.title': 'Nhập voucher',
  'voucher.router.name': 'Voucher quy đổi',
  //transfer gift
  'giftTransfer.modal.ranking.title': 'Chuyển quà tặng xếp hạng qua quà tặng khác',
  'giftTransfer.modal.other.title': 'Chuyển quà tặng khác qua quà tặng xếp hạng',

  'giftTransfer.modal.ranking.selectGift': 'Quà tặng khác cần nhận',
  'giftTransfer.modal.other.selectGift': 'Quà tặng xếp hạng cần nhận',
  'giftTransfer.modal.selectGift.placeholder': 'Chọn quà',
  'giftTransfer.modal.quantity': 'Tổng số lượng quà cần chuyển',
  'giftTransfer.modal.quantity.placeholder': 'Nhập số lượng',
  'giftTransfer.modal.button.addGift': 'Thêm quà',
  'giftTransfer.modal.button.transfer': 'Chuyển',
  'giftTransfer.modal.warn.sufficientAmount': 'Không đủ số lượng để chuyển',

  'gift-table.code': 'Mã voucher',
  'gift-table.operationStatus': 'Trạng thái hoạt động',

  'gift-import.title.update': 'Cập nhật trạng thái hoạt động',
  'gift-import.content.update': 'Bạn có chắc chắn muốn cập nhật những trạng thái đã chọn không?',
  'gift-import.title.delete': 'Xóa Voucher',
  'gift-import.content.delete': 'Bạn có chắc chắn muốn xóa voucher?',

  'gift-import-other.code': 'Mã voucher',
  'gift-import-other.shortLink': 'Link rút gọn',
  'gift-import-other.operationStatus': 'Trạng thái hoạt động',
  'gift-import-other.receivingTime': 'Thời gian nhận',
  'gift-import-other.createdAt': 'Thời gian thêm',
  'gift-import-other.receiveStatus': 'Trạng thái nhận',
  'gift-import-other.usageStatus': 'Trạng thái sử dụng',
  'gift-import-other.receiveStatus.params':
    '{status,select, 1 {Đã nhận} 2 {Chưa nhận} other {Không xác định}}',
  'gift-import-other.usageStatus.params':
    '{status,select, 1 {Đã sử dụng} 2 {Chưa sử dụng} other {Không xác định}}',

  'gift-import-other.Active': 'Đang hoạt động',
  'gift-import-other.Deactive': 'Dừng hoạt động',
  'gift-import-other.Received': 'Đã nhận',
  'gift-import-other.NotReceived': 'Chưa nhận',
  'gift-import-other.Used': 'Đã sử dụng',
  'gift-import-other.NotUsed': 'Chưa sử dụng',

  'gift-import-ranking.total': 'Tổng số mã voucher',
  'gift-import-ranking.totalReceived': 'Số mã voucher đã nhận',
  'gift-import-ranking.totalNotReceived': 'Số mã voucher chưa nhận',
  'gift-import-ranking.totalActive': 'Số mã voucher chưa nhận',
  'gift-import-ranking.totalDeactive': 'Số mã voucher chưa nhận',

  'gift-import-ranking.code': 'Mã voucher',
  'gift-import-ranking.operationStatus': 'Trạng thái hoạt động',
  'gift-import-ranking.receivingTime': 'Thời gian nhận',
  'gift-import-ranking.createdAt': 'Thời gian thêm',
  'gift-import-ranking.receiveStatus': 'Trạng thái nhận',
  'gift-import-ranking.usageStatus': 'Trạng thái sử dụng',
  'gift-import-ranking.receiveStatus.params':
    '{status,select, 1 {Đã nhận} 2 {Chưa nhận} other {Không xác định}}',
  'gift-import-ranking.usageStatus.params':
    '{status,select, 1 {Đã sử dụng} 2 {Chưa sử dụng} other {Không xác định}}',
  'gift-import.edit': 'Chỉnh sửa trạng thái hoạt động',
  'gift-import-ranking.shortLink': 'Link rút gọn',
  'gift-table.shortLink': 'Link rút gọn',

  'gift-import.title.status.update': 'Cập nhật trạng thái hoạt động',
  'gift-import.content.status.update':
    'Bạn có chắc chắn muốn cập nhật những trạng thái đã chọn không?',

  'gift-import.title.warning': 'Không thể cập nhật voucher',
  'gift-import.content.warning':
    'Bạn đã chọn cả hai voucher đang hoạt động và dừng hoạt động nên không thể cập nhật',

  'gift.exchange.title': 'Quà quy đổi',
  'Exchange.gifts.tab': 'Quà quy đổi',
  'gift.exchange.title-name': 'Danh sách quà quy đổi',
  'gift.ranking.price': 'Giá',
  'gift.ranking.usedQuantity': 'Số lượng đã sử dụng',
  'gift.ranking.businessStatus': 'Trạng thái hoạt động',
  'gift.businessStatus.param':
    '{status,select, 1 {Đang kinh doanh} 2 {Chưa kinh doanh} 3 {Kết thúc} 4 {Ngừng kinh doanh} other {Không xác định}}',

  'voucher-import.title-exchange': 'Quy đổi voucher',
  'voucher-import.title-Exchange': 'Chọn voucher',
  'voucher-import.title-Exchange-router': 'Voucher quy đổi',
  'gift-import-exchange.code': 'Mã voucher',
  'gift-import-exchange.receivingTime': 'Thời gian nhận',
  'gift-import-exchange.createdAt': 'Thời gian thêm',
  'gift-import-exchange.shortLink': 'Link rút gọn',
  'gift-import-exchange.operationStatus': 'Trạng thái hoạt động',
  'gift-import-exchange.receiveStatus': 'Trạng thái nhận',
  'gift-import-exchange.usageStatus': 'Trạng thái sử dụng',
  'giftInfo.exchange.customer.title': 'Danh sách khách hàng nhận quà quy đổi',
  'giftInfo.exchange.gift.title': 'Thông tin quà quy đổi',
  'giftInfo.exchange.customer.title-table': 'Danh sách khách hàng nhận quà quy đổi',
  'addGift.exchange.title': 'Thêm quà quy đổi',
  'addGift.form.BusinessStatus': 'Trạng thái hoạt động',
  'addGift.form.time': 'Thời gian',
  'addGift.form.Price': 'Giá',
  'updateGift.exchange.title': 'Cập nhật quà quy đổi',

  // Gift by device
  'giftByDevice.tab.name': 'Quà theo thiết bị',
  'giftByDevice.router.name': 'Quà theo thiết bị',
  'giftByDevice.title': 'Danh sách quà tặng tại thiết bị',
  'giftByDevice.operating.status': 'Trạng thái hoạt động',
  'giftByDevice.operating.status.params':
    '{status,select, 1 {Khả dụng} 2 {Không khả dụng} other {Không xác định}}',
  'giftByDevice.actions.delete.title': 'Xác nhận xóa quà tặng',
  'giftByDevice.actions.delete.content':
    'Bạn có chắc chắn muốn xóa quà tặng này khỏi thiết bị không?',
  'giftByDevice.modal.create': 'Thêm quà tặng',
  'giftByDevice.modal.update': 'Cập nhật quà tặng',
  'giftByDevice.modal.information': 'Thông tin quà tặng',
  'giftByDevice.modal.score': 'Điểm quy đổi',
  'giftByDevice.modal.status.available': 'Khả dụng',
  'giftByDevice.modal.status.unAvailable': 'Không khả dụng',

  //
  'gift.exchange2.router.name': 'Danh mục quà',
  'gift.totalRewardItemInLine': 'Tổng số dòng được gắn',
  'gift.redeemedQuantity': 'Số lượng đã phát',
  'gift.availableQuantity': 'Số lượng khả dụng',
  'gift-by-device.mode.add': 'Nạp quà',
  'gift-by-device.mode.list': 'Danh sách quà',
};
